<template>
  <div class="container-fluid py-3">
    <h3 v-html="title"></h3>
    <p v-html="body"></p>
    <div class="text-center" v-if="!isFullscreen">
      <button type="button"
              class="btn btn-wide btn-primary"
              v-on:click="closeApplication">
        Close
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as postMessageAPIs from '@/api/postMessageToWindow';
import SegmentMixin from '@/mixins/SegmentMixin';

export default {
  name: 'FiveZeroZero',
  mixins: [
    SegmentMixin,
  ],
  data() {
    return {
      defaultTitle: 'We\'re sorry, something has gone wrong.',
      defaultBody: `A service is not responding as expected and as a result we
                    cannot check your data with our customer database.<br><br>
                    We should be able to correct this issue shortly, please check back later.`,
    };
  },
  computed: {
    ...mapGetters('cmsText', [
      'getCMSText',
    ]),

    title() {
      return this.getCMSText('five_hundred_error:title') || this.defaultTitle;
    },

    body() {
      return this.getCMSText('five_hundred_error:body') || this.defaultBody;
    },
    isFullscreen() {
      return (/true/).test(this.$route?.query.fullScreen);
    },
  },
  methods: {
    closeApplication() {
      const data = {
        close: true,
        reason: 'serverError',
        location: 'five-zero-zero',
        data: {
          hasShippingData: this.$store.state.hasShippingData,
        },
      };
      const callback = () => postMessageAPIs.default(data);
      this.trackEvent(
        'FiveZeroZero Closed',
        null,
        callback,
      );
    },
  },
};
</script>
